<template functional>
  <b-dropdown :class="{ 'drop-up': props.dropUpDirection }"
              position="is-bottom-left"
              class="dropdown-select-normal"
              @change="props.changeItemHandler">
    <p slot="trigger">
      <span @click="props.clickItemHandler">
        <slot></slot>
      </span>
    </p>
    <p><i class="arrow-point"></i></p>
    <div v-if="!props.availableItems" class="loader"></div>
    <b-dropdown-item v-for="(label, value) in props.availableItems"
                     :key="label"
                     :value="value"
                     :title="label"
                     :class="{'is-active': value === props.preselectedItem}"
                     :separator="value === 'null'">
      {{ label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    availableItems: Object,
    changeItemHandler: Function,
    clickItemHandler: {type: Function, default: () => {}},
    dropUpDirection: {type: Boolean, default: false},
    preselectedItem: String
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  &.dropdown-select-normal {
    .label-value {
      font-size: var(--size-16);
      font-weight: bold;
      color: var(--gray);
      cursor: pointer;
      line-height: 2.25;
    }
    .edit-icon {
      margin: -2px 0 0 1px;
    }
    i {
      display: inline-block;
      padding: 6px;
      position: absolute;
      background: white;
      top: -2px;
      left: 222px;
      box-shadow: 5px 0 5px -4px var(--mid-gray), 0 5px 5px -4px var(--mid-gray);
    }
    .arrow-point {
      transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
    }
    /deep/ .dropdown-content {
      border-radius: 6px;
      box-shadow: 0 5px 20px 0 var(--mid-gray);
      width: 300px;
      a {
        text-align: left;
        overflow: hidden;
      }
    }
    /deep/ .dropdown-menu {
      right: -52px;
      top: 27px;
    }
  }

  &.drop-up {
    i {
      box-shadow: none;
      padding: 6px;
      top: 498px;
    }
    /deep/ .dropdown-menu {
      top: -515px;
    }
  }
  .loader {
    width: 100px;
    height: 100px;
    margin: 200px auto;
  }
}
</style>
